var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56_2957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2667 2.86664H2.83337V21.3H21.2667V2.86664Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.7417 21.3H16.625L10.8584 10.5667C10.3 9.52498 9.05837 9.52498 8.50003 10.5667L2.7417 21.3Z",
    fill: "#0A3B87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2084 21.3H20.625L17.55 15.5666C17.25 15.0083 16.5917 15.0083 16.2917 15.5666L13.2167 21.3H13.2084Z",
    fill: "#F28629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6 22H4.4C3.075 22 2 20.925 2 19.6V4.4C2 3.075 3.075 2 4.4 2H19.6C20.925 2 22 3.075 22 4.4V19.6C22 20.925 20.925 22 19.6 22ZM4.4 2.84167C3.54167 2.84167 2.84167 3.54167 2.84167 4.4V19.6C2.84167 20.4583 3.54167 21.1583 4.4 21.1583H19.6C20.4583 21.1583 21.1583 20.4583 21.1583 19.6V4.4C21.1583 3.54167 20.4583 2.84167 19.6 2.84167H4.4Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.225 11.4917C15.9982 11.4917 16.625 10.8648 16.625 10.0917C16.625 9.31845 15.9982 8.69165 15.225 8.69165C14.4518 8.69165 13.825 9.31845 13.825 10.0917C13.825 10.8648 14.4518 11.4917 15.225 11.4917Z",
    fill: "#F28629"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56_2957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.590e988e37636c72d3d812bf5143e781.svg";
export { ForwardRef as ReactComponent };